import { AgentInfo } from '@/interfaces/agent';
import request from '@/utils/request';

export const getAgents = () => {
  return request<{ list: AgentInfo[] }>({ url: '/v1/ent/agent/list', method: 'POST' });
};

export const createAgent = (data: Partial<AgentInfo>) => {
  return request({ url: '/v1/ent/agent/create', method: 'POST', data });
};
export const updateAgent = (data: Partial<AgentInfo>) => {
  return request({ url: '/v1/ent/agent/update', method: 'PATCH', data });
};
export const updateAgentPassword = (data: Pick<AgentInfo, 'id' | 'password'>) => {
  return request({ url: '/v1/ent/agent/password', method: 'PUT', data });
};

export const updateSelfPassword = (data: { password: string; newPassword: string }) => {
  return request({ url: '/v1/ent/agent/self-password', method: 'PUT', data });
};
